import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import bcrypt from 'bcryptjs'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 3000000 // request timeout
})
if(process.env.NODE_ENV==='development'){
    service.defaults.baseURL = 'http://183.246.91.252:51335/api'
}
// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            var token = getToken()
            var tick = new Date().getTime()
            var salt = bcrypt.genSaltSync(12)
            var hash = bcrypt.hashSync(token + tick, salt)

            config.headers['X-Token'] = hash
            config.headers['X-UserName'] = store.getters.username
            config.headers['X-Tick'] = tick

            if (config.url.indexOf('hep2') >= 0) {
                console.log('HEP2DBMark:' + store.state.settings.HEP2DBMark)
                if (config.url.indexOf('?') === -1) {
                    config.url = config.url + '?'
                }
                if (!config.params || !config.params.HEP2DBMark) {
                    if (!config.params) {
                        config.params = {}
                    }
                    config.params.HEP2DBMark = store.state.settings.HEP2DBMark
                    config.params.HEP2Database = store.state.settings.HEP2Database
                }
            }
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // eslint-disable-next-line no-prototype-builtins
    if (!res.hasOwnProperty('status')) {
        return res
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.status !== 0) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.statusCode === 401) {
        // to re-login
        MessageBox.confirm(res.msg, '确认', {
          confirmButtonText: '重新登陆',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
